export default __webpack_public_path__ + "static/media/ekta-ghag.998e8c4f.jpg";